import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { clearAccessToken, ensureAccessToken } from '../../auth/token.service';

const rawBaseQuery = fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_API_URL });

const withAuth = (args, token) => {
  if (typeof args === 'string') return { url: args, headers: { Authorization: `Bearer ${token}` } };
  return {
    ...args,
    headers: { ...(args.headers || {}), Authorization: `Bearer ${token}` },
  };
};

export const baseQueryWithAuth = async (args, api, extraOptions) => {
  let token = await ensureAccessToken();
  let result = await rawBaseQuery(withAuth(args, token), api, extraOptions);

  if (result?.error?.status === 401) {
    clearAccessToken();
    token = await ensureAccessToken({ forceRefresh: true });
    result = await rawBaseQuery(withAuth(args, token), api, extraOptions);
  }

  return result;
};
